import { mapState, mapGetters } from 'vuex'
import { currencyUnitMap } from '@/constants/currency'

export default {
  computed: {
    ...mapGetters(['scope', 'isDomainMode']),
    ...mapState('common', {
      currency: state => state.bill.currency,
      globalCurrency: state => state.bill.currency,
      exchangeRateAvailable: state => state.bill.exchangeRateAvailable,
    }),
    currencySign () {
      if (currencyUnitMap[this.currency]) {
        return currencyUnitMap[this.currency].sign || ''
      }
      return ''
    },
    currencyCn () {
      if (currencyUnitMap[this.currency]) {
        return currencyUnitMap[this.currency].cn || ''
      }
      return ''
    },
    currencyParams () {
      if (this.currency) {
        const params = {
          exchanged_currency: this.currency.replace('*', '').replace('_', ''),
          filter: [`currency.equals("${this.currency.replace('*', '').replace('_', '')}")`],
        }
        if (this.currency.indexOf('_') !== -1) {
          params.filter = ''
        } else {
          params.exchanged_currency = ''
        }
        params.disable_cost_conversion = this.currency.indexOf('*') !== -1 || !this.$store.state.common.bill.globalConfig.cost_conversion_available
        if (!params.disable_cost_conversion && this.scope !== 'system') {
          params.secondary_price = true
        }
        return params
      }
      return {}
    },
  },
  watch: {
    currency () {
      this.list && (this.list.data = {})
      this.fetchData && this.fetchData()
    },
  },
}
